
// Las notas de alarma se guardan en { items: [{ note, applicantName, timestamp }] }
// (ver getViewNotesContainer / getAlarmNotesAsync). El payload de postAlarmNoteAsync
// es { newNote: { referenceId, note }, applicantName }. Añadimos la nueva nota al
// final de items de forma optimista; el refetch posterior la sustituye con los
// datos definitivos (id/timestamp del backend).
export const updateAlarmNotesData = (payload: any, alarmNotesData: any) => {
  return {
    ...alarmNotesData,
    items: [
      ...(alarmNotesData?.items ?? []),
      {
        note: payload?.newNote?.note,
        applicantName: payload?.applicantName,
        timestamp: payload?.newNote?.timestamp,
      },
    ],
  };
};